import React from 'react';

import '@/style/components/MaterialProgressBar.scss';

export function MaterialProgressBar() {
  return (
    <div className="progress-container">
      <div className="progress-materializecss">
        <div className="indeterminate"></div>
      </div>
    </div>
  );
}
